import { render, staticRenderFns } from "./AdvertiserContactEdit.vue?vue&type=template&id=4573d78b&scoped=true"
import script from "./AdvertiserContactEdit.vue?vue&type=script&lang=js"
export * from "./AdvertiserContactEdit.vue?vue&type=script&lang=js"
import style0 from "./AdvertiserContactEdit.vue?vue&type=style&index=0&id=4573d78b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4573d78b",
  null
  
)

export default component.exports